import React, { useEffect } from 'react';
import hive from "./index"
import { useState } from "@hookstate/core"
import LotCard from './LotCard';
import layouts from "./project/layouts"
import { ArrowLeft, ArrowRight } from '@material-ui/icons';

function FavoriteTarget({ lotState }: any) {
  // width: totalWidth.get() * 0.49,
  // height: height.get() * 0.65,
  const { height, totalWidth, mainColor } = useState(hive.state)

  const lot = useState(lotState)
  const targetLot = Object.values(hive.lots).find((l: any) => l.id === lot.get()) as any
  const imgs = useState(null)
  const imgsIndex = useState(0)

  useEffect(() => {
    imgsIndex.set(0)
    if (targetLot) {
      const layout = (layouts as any)[targetLot.layout];
      const imgsValue = layout.botMenu
        .map((l: any) => (layouts as any)[l.target]).
        filter((e: any) => e.image)
        .map((e: any) => {
          return targetLot[e.image.replace("%", "").replace("%", "")]
        })
      console.log(imgsValue);
      imgs.set(imgsValue)
    }

  }, [lot.get()])


  return <div style={{}}>
    {imgs.get() && <>
      <div style={{
        position: "absolute",
        top: height.get() * 0.65 * 0.5 + "px",
        width: totalWidth.get() * 0.05,
        height: totalWidth.get() * 0.05,
        // borderRadius: totalWidth.get() * 0.04 * 0.5,
        // border: `1px solid #${mainColor.get()}`,
        opacity: imgsIndex.get() > 0 ? "1" : "0.2",
        cursor: imgsIndex.get() > 0 ? "pointer" : "initial",
        // marginLeft: height.get() * 0.01 + "px"
      }}
        onClick={() => {
          if (imgsIndex.get() > 0) {
            imgsIndex.set(e => e - 1)
          }
        }}
      >
        <ArrowLeft style={{
          color: `#${mainColor.get()}`,
          width: totalWidth.get() * 0.05 + "px",
          height: totalWidth.get() * 0.05 + "px",
        }}></ArrowLeft>
      </div>

      <div style={{
        position: "absolute",
        top: height.get() * 0.65 * 0.5 + "px",
        marginLeft: totalWidth.get() * 0.49 - totalWidth.get() * 0.04,
        width: totalWidth.get() * 0.05,
        height: totalWidth.get() * 0.05,
        // borderRadius: totalWidth.get() * 0.04 * 0.5,
        // border: `1px solid #${mainColor.get()}`,
        opacity: imgsIndex.get() < (imgs.get() as any).length - 1 ? "1" : "0.2",
        cursor: imgsIndex.get() < (imgs.get() as any).length - 1 ? "pointer" : "initial",
      }}
        onClick={() => {
          if (imgsIndex.get() < (imgs.get() as any).length - 1) {
            imgsIndex.set(e => e + 1)
          }
        }}
      >
        <ArrowRight style={{
          color: `#${mainColor.get()}`,
          width: totalWidth.get() * 0.05 + "px",
          height: totalWidth.get() * 0.05 + "px",
        }}></ArrowRight>
      </div>
    </>}
    {!imgs.get() && <>
      <div style={{
        width: "100%",
        height: height.get() * 0.65,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}>
        <div style={{
          display: "flex",
          justifyContent: "center",
          width: totalWidth.get() * 0.49,

        }}>
          <div style={{
            width: height.get() * 0.45,
            height: height.get() * 0.22,
            textAlign: "center",
            color: `#${mainColor.get()}`
          }}>
            <div style={{
              fontSize: height.get() * 0.03,
              fontFamily: "MuktaBold",
            }}

            >COMPARER</div>
            <div style={{
              fontSize: height.get() * 0.2 + "px",
              margin: -height.get() * 0.1 + "px",
            }}>+</div>
            <div
              style={{
                fontSize: height.get() * 0.02 + "px",
              }}
            >Glissez déposer vos favoris pour les comparer</div>
          </div>
        </div>

      </div>
    </>}

    {imgs.get() && <>
      {((imgs.get() as any)[imgsIndex.get()] as string).endsWith("pdf") && <div>
        <embed
          width={`100%`}
          height={height.get() * 0.65 + "px"}
          src={`${window.location.href}/${(imgs.get() as any)[imgsIndex.get()]}`}  ></embed>
      </div>
      }
      {!((imgs.get() as any)[imgsIndex.get()] as string).endsWith("pdf") && <div style={{
        width: "100%",
        height: height.get() * 0.65,
        backgroundImage: `url(${(imgs.get() as any)[imgsIndex.get()]})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
      }}>
      </div>
      }

    </>
    }


  </div>
}

function Favorites() {
  const { height, totalWidth, mainColor, favoriteList, favoriteLeft, favoriteRight } = useState(hive.state)

  const overDrop = useState("")
  const lotDrop = useState("")
  const dragging = useState(false)

  const getLotfromId = (id: string) => {
    const res = Object.values(hive.lots).find((lot: any) => lot.id === id)
    return res
  }

  const touchStart = (fav: string) => {
    (document.querySelector("#grabTooltip") as HTMLElement).style.visibility = `initial`;
    overDrop.set("")
    lotDrop.set(fav)
    dragging.set(true)
  }

  const touchMove = (x: number, y: number) => {
    if (x !== 0 && y !== 0) {
      (document.querySelector("#grabTooltip") as HTMLElement).style.top = `${y}px`;
      (document.querySelector("#grabTooltip") as HTMLElement).style.left = `${x}px`;
      const el = (document.elementFromPoint(x, y) as HTMLElement).getAttribute("id");
      (document.querySelector("#grabTooltip") as HTMLElement).style.visibility = (el === "drop_0" || el === "drop_1") ? "initial" : "hidden";

      if (el !== null) {
        if (overDrop.get() !== el) {
          overDrop.set(el)
        }
      }
    }
  }

  const touchEnd = () => {
    if (overDrop.get()) {
      if (overDrop.get() === "drop_0") {
        favoriteLeft.set(lotDrop.get())
      }
      if (overDrop.get() === "drop_1") {
        favoriteRight.set(lotDrop.get())
      }
    }
    lotDrop.set("")
    overDrop.set("");
    dragging.set(false);
    (document.querySelector("#grabTooltip") as HTMLElement).style.visibility = `hidden`;
  }

  useEffect(() => {
    const callBack = (e: any) => {
      touchMove(e.pageX, e.pageY)
      // console.log(e.pageX)
    }

    const d = document.addEventListener("dragover", callBack, true)
    return () => {
      document.removeEventListener("dragover", callBack, true)
    }
  }, [])

  return <div style={{
    position: "absolute",
    height: height.get(),
    background: "#dadada",
    width: totalWidth.get(),
    zIndex: 1,
  }}>
    <div
      id="grabTooltip"
      style={{
        position: "fixed",
        width: height.get() * 0.1,
        height: height.get() * 0.1,
        backgroundImage: "url(/gui/drag.png)",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        zIndex: 5,
        visibility: "hidden",
        pointerEvents: "none",
      }}>

    </div>

    {/* return space */}
    <div style={{
      height: height.get() * 0.07,
    }}>

    </div>

    {/* comparator */}

    <div style={{
      height: height.get() * 0.70,
      display: "flex",
      justifyContent: "space-evenly",
    }}>
      {[0, 1].map(e =>
        <div key={e}
          style={{
            width: totalWidth.get() * 0.49,
            height: height.get() * 0.65,
            border: overDrop.get() === `drop_${e}` ? `2px #${mainColor.get()} solid` : `2px #${mainColor.get()} dashed`,
            backgroundColor: overDrop.get() === `drop_${e}` ? `#${mainColor.get()}66` : "inherit"
          }}
        >
          <div
            id={`drop_${e}`}
            style={{
              position: "absolute",
              pointerEvents: dragging.get() ? "initial" : "none",
              width: totalWidth.get() * 0.49,
              height: height.get() * 0.65,
            }}>
          </div>
          <FavoriteTarget lotState={e == 0 ? favoriteLeft : favoriteRight}></FavoriteTarget>
        </div>
      )}

    </div>

    {/* list */}
    <div style={{
      height: height.get() * 0.225,
      width: "100vw",
      display: "flex",
      // border : "1px solid blue"
      overflowX: "scroll",
    }}>
      {favoriteList.map((fav, i) =>
        <div
          draggable="true"
          onDragStart={(e) => {
            e.dataTransfer.setData('Text', "");
            touchStart(fav.get())
          }}

          // onDrag={(e) => {
          //   touchMove(e.pageX, e.pageY)
          // }}

          onDragEnd={(e) => {
            touchEnd()
          }}

          onTouchStart={() => {
            touchStart(fav.get())
          }}

          onTouchMove={(e) => {
            const x = e.targetTouches[0].clientX
            const y = e.targetTouches[0].clientY
            touchMove(x, y)
          }}

          onTouchEnd={(e) => {
            touchEnd()
          }}
          key={fav.get()}
          style={{
            cursor: "grab",
            width: totalWidth.get() * 0.25,
            minWidth: totalWidth.get() * 0.25,
            height: height.get() * 0.20,
            // background: "red",
            marginLeft: height.get() * 0.01,
          }}
        >
          <LotCard width={0.25} height={0.22} lot={getLotfromId(fav.get())}></LotCard>
        </div>
      )}
    </div>
  </div>
}


export default Favorites